const DirectTransactionTimeout = 2500;

export const TRANSACTIONS_CONFIGURATION = {
  RUN_QUERY: {
    timeout: DirectTransactionTimeout,
  },
};
